module.exports = __webpack_public_path__ + "static/media/daisie-flipbook-white.3106d3d6.png";